import {
  Facebook,
  Instagram,
  Youtube,
  Twitter,
  Phone,
  Mail,
} from "lucide-react";
import { site } from "@/data/siteContent";
import BrandLogo from "@/components/site/BrandLogo";

const QUICK = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "testimonials", label: "Testimonials" },
  { id: "gallery", label: "Gallery" },
  { id: "faq", label: "FAQ" },
  { id: "booking", label: "Book" },
];

const SERVICES_SHORT = [
  "Vashikaran",
  "Love Problem",
  "Marriage",
  "Husband–Wife",
  "Business",
  "Career",
  "Family",
  "Love Marriage",
];

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="relative pt-20 pb-10 border-t border-white/5 bg-[#050B14]"
    >
      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 top-0 h-40 opacity-40"
        style={{
          backgroundImage:
            "radial-gradient(ellipse 60% 40% at 50% 0%, rgba(212,175,55,0.15), transparent 60%)",
        }}
      />
      <div className="container-luxe relative grid lg:grid-cols-[1.3fr_0.8fr_0.8fr_1fr] gap-10">
        <div>
          <div className="flex items-center gap-3">
            <BrandLogo size={46} />
            <span className="flex flex-col leading-tight">
              <span className="font-display text-[15px] tracking-[0.22em] text-cream">
                JAY AMBE
              </span>
              <span className="font-display text-[10px] tracking-[0.4em] text-gold">
                JYOTISH
              </span>
            </span>
          </div>
          <p className="mt-5 text-cream-muted text-[13.5px] leading-relaxed max-w-sm">
            Authentic Vedic astrology consultations rooted in centuries of
            tradition, offered with warmth, discretion and unwavering
            integrity.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[
              { href: site.socials.facebook, Icon: Facebook, k: "fb" },
              { href: site.socials.instagram, Icon: Instagram, k: "ig" },
              { href: site.socials.youtube, Icon: Youtube, k: "yt" },
              { href: site.socials.twitter, Icon: Twitter, k: "tw" },
            ].map(({ href, Icon, k }) => (
              <a
                key={k}
                href={href}
                data-testid={`footer-social-${k}`}
                aria-label={k}
                className="w-10 h-10 grid place-items-center rounded-full gold-border text-gold hover:bg-[#D4AF37] hover:text-[#050B14] transition-colors duration-500"
              >
                <Icon className="w-4 h-4" strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <div className="font-display text-[11px] tracking-[0.32em] text-gold">
            EXPLORE
          </div>
          <ul className="mt-5 space-y-3">
            {QUICK.map((q) => (
              <li key={q.id}>
                <a
                  href={`#${q.id}`}
                  data-testid={`footer-link-${q.id}`}
                  className="text-cream-muted text-[13.5px] hover:text-gold transition-colors"
                >
                  {q.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-display text-[11px] tracking-[0.32em] text-gold">
            SERVICES
          </div>
          <ul className="mt-5 space-y-3">
            {SERVICES_SHORT.map((s) => (
              <li
                key={s}
                className="text-cream-muted text-[13.5px]"
              >
                {s}
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="font-display text-[11px] tracking-[0.32em] text-gold">
            REACH OUT
          </div>
          <ul className="mt-5 space-y-4">
            <li className="flex items-start gap-3 text-cream-muted text-[13.5px]">
              <Phone className="w-4 h-4 text-gold mt-0.5" strokeWidth={1.5} />
              {site.contact.phone}
            </li>
            <li className="flex items-start gap-3 text-cream-muted text-[13.5px]">
              <Mail className="w-4 h-4 text-gold mt-0.5" strokeWidth={1.5} />
              {site.contact.email}
            </li>
            <li className="text-cream-muted text-[13.5px]">
              {site.contact.hours}
            </li>
          </ul>
        </div>
      </div>

      <div className="container-luxe relative mt-14 pt-6 border-t border-white/5 flex flex-wrap items-center justify-between gap-4">
        <div className="text-[11px] tracking-[0.28em] uppercase text-cream-muted">
          © {new Date().getFullYear()} {site.brand.name} · All rights reserved
        </div>
        <div className="font-devanagari text-[13px] text-gold-light">
          ॐ शान्ति शान्ति शान्तिः
        </div>
      </div>
    </footer>
  );
}
